import { AiBody } from '../../layout/AiPanel';
import { useCrumbs } from '../../layout/crumbs';
import { Page, PageHeader, Panel } from '../../ui/layout';

/**
 * «Pilot» из меню: тот же помощник, что кнопка «Спросить Pilot» в шапке, — вопрос, ответ по инструкциям и базе
 * знаний со ссылками, «Помогло» или «В поддержку». Если Pilot недоступен, страница говорит почему.
 */
export function PilotPage() {
  useCrumbs([{ label: 'Pilot' }]);
  return (
    <Page>
      <PageHeader
        title="Pilot"
        subtitle="Собственная ИИ-модель портала. Отвечает, как работать в портале, по инструкциям и статьям базы знаний в пределах ваших прав; ответ помечен «Подготовлено ИИ». Тот же Pilot открывается кнопкой «Спросить Pilot» в шапке на любой странице."
      />
      <Panel title="Спросить Pilot">
        <AiBody />
      </Panel>
    </Page>
  );
}
